import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Portfolio from "@/components/site/Portfolio";
import Stats from "@/components/site/Stats";
import Manifesto from "@/components/site/Manifesto";
import QuoteForm from "@/components/site/QuoteForm";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import Admin from "@/components/site/Admin";
import ServicePage from "@/components/site/ServicePage";
import { initPixels } from "@/lib/pixels";

const Home = () => {
  return (
    <div className="App grain bg-[#0A0A0A]" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Portfolio />
        <Stats />
        <Manifesto />
        <FAQ />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    initPixels();
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            border: "1px solid #333333",
            borderRadius: 0,
            fontFamily: "JetBrains Mono, monospace",
            color: "#F5F5F5",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
